import API from '../helpers/api';
import * as ActionTypes from '../constants/ActionTypes';
import { getPointOfInterestTypes } from './MapPage';

export function getBuildingFloorGeojson(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_REQUEST,
			payload: { loading_building_floor: true }
		});

		const response = await API.building_floors.getBuildingFloorGeojson(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_GEOJSON_ERROR,
				payload: {
					meta: response.meta,
					loading_building_floor: false,
					building_floor: null
				}
			});
			return;
		}

		const { building_floor } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_SUCCESS,
			payload: {
				loading_building_floor: false,
				building_floor
			}
		});
	};
}

export function getBuildingFloorNavNodes(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_REQUEST,
			payload: { loading_nav_nodes: true }
		});

		const response = await API.building_floors.getBuildingFloorNavNodes(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_GEOJSON_ERROR,
				payload: {
					meta: response.meta,
					loading_nav_nodes: false
				}
			});
			return;
		}

		const { nav_nodes } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_SUCCESS,
			payload: {
				loading_nav_nodes: false,
				nav_nodes
			}
		});
	};
}

export function getBuildingFloorPointOfInterests(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_REQUEST,
			payload: { loading_point_of_interests: true }
		});

		const response = await API.building_floors.getBuildingFloorPointOfInterests(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_GEOJSON_ERROR,
				payload: {
					meta: response.meta,
					loading_point_of_interests: false
				}
			});
			return;
		}

		const { point_of_interests } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_SUCCESS,
			payload: {
				loading_point_of_interests: false,
				point_of_interests
			}
		});
	};
}

export function getLocationBuildingFloorsById(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_BUILDING_FLOORS_REQUEST,
			payload: { loading_building_floors: true }
		});

		const response = await API.location_building_floors.getLocationBuildingFloorsById(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_BUILDING_FLOORS_ERROR,
				payload: {
					meta: response.meta,
					loading_building_floors: false
				}
			});
			return;
		}

		const { location_building_floors } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_BUILDING_FLOORS_SUCCESS,
			payload: {
				loading_building_floors: false,
				location_building_floors
			}
		});
	};
}

export function getLocationAssetsByLocationId(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_ASSETS_REQUEST,
			payload: { loading_assets: true }
		});

		const response = await API.asset.getLocationAssetsByLocationId(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_ASSETS_ERROR,
				payload: {
					meta: response.meta,
					loading_assets: false,
					location_assets: null
				}
			});
			return;
		}

		const { assets } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_ASSETS_SUCCESS,
			payload: {
				loading_assets: false,
				location_assets: assets
			}
		});
	};
}

export function getLocationDetailsById(options) {
	return async (dispatch, getState) => {
		dispatch({
			type: ActionTypes.GET_LOCATION_DETAIL_REQUEST,
			payload: { loading_details: true }
		});

		const response = await API.location_details.getLocationDetailsById(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_DETAIL_ERROR,
				payload: {
					meta: response.meta,
					loading_details: false
				}
			});
			return;
		}

		const { location: location_details } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_DETAIL_SUCCESS,
			payload: {
				loading_details: false,
				location_id: null,
				location_details
			}
		});

		// dispatch(getLocationBuildingFloorsById({ building_id: location_details.building_id, limit: 50 }));
		dispatch(getLocationAssetsByLocationId({ id: location_details._id, file_extension: ['jpeg', 'png', 'jpg'] }));
		dispatch(getPointOfInterestTypes());
	};
}

export function getLocaationIdByRemoteId(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_LOCATION_ID_BY_REMOTE_ID_REQUEST,
			payload: { loading_details: true }
		});

		const response = await API.location_details.getLocaationIdByRemoteId(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_ID_BY_REMOTE_ID_ERROR,
				payload: {
					meta: response.meta,
					loading_details: false
				}
			});
			return;
		}

		const { location_id } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_ID_BY_REMOTE_ID_SUCCESS,
			payload: {
				loading_details: false,
				location_id
			}
		});
	};
}

export function resetMeta() {
	return async dispatch =>
		dispatch({ type: ActionTypes.RESET_LOCATION_DETAIL_META });
};

export function resetPage() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_LOCATION_DETAIL_PAGE });
	};
}